export const classifications = {
  'Likely False Alarm': {
    label: 'Likely false alarm',
    class: 'likely-false-alarm',
  },
  'Likely Trip': {
    label: 'Likely trip',
    class: 'likely-trip',
  },
  'Likely Energization': {
    label: 'Likely energization',
    class: 'likely-energization',
  },
  'Likely De-energization': {
    label: 'Likely de-energization',
    class: 'likely-de-energization',
  },
  'CF - likely AC error': {
    label: 'CF - likely AC error',
    class: 'cf-likely-ac-error',
    tooltip: 'Indicates commutation failure likely related to an AC error',
  },
  'CF - likely not AC error': {
    label: 'CF - likely not AC error',
    class: 'cf-likely-not-ac-error',
    tooltip: 'Indicates commutation failure likely not related to an AC error',
  },
};

export const filterMapping = {
  showNoClassification: 'No Classification',
  showLikelyTrip: 'Likely Trip',
  showLikelyEnergization: 'Likely Energization',
  showLikelyDeEnergization: 'Likely De-energization',
  showLikelyFalseAlarm: 'Likely False Alarm',
  showCFLikelyACError: 'CF - likely AC error',
  showCFLikelyNotACError: 'CF - likely not AC error',
};

export const normalizeClassification = (classification) => {
  if (!classification) return null;
  const trimmed = classification.trim();
  const key = Object.keys(classifications).find((k) => k.toLowerCase() === trimmed.toLowerCase());
  return key || classification;
};
